import state from '../state'
import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
import { q1O } from '../util/nE'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(SplitText, ScrollToPlugin)

class PostContent {
  constructor (el) {
    this.el = el
    this.date = this.el.querySelector('.post-content__header-date')
    this.title = this.el.querySelector('.post-content__header-title')
    this.tags = this.el.querySelectorAll('.post-content__header-tags')
    this.image = this.el.querySelector('.post-content__image')
    this.line = this.el.querySelector('.line')
    this.content = this.el.querySelector('.post-content__content-row')
    this.scrollTo = document.querySelector('.sroll-to')
    this.wysiwyg = document.querySelector('.wysiwyg')
    // this.isGated = this.el.dataset.gated === 'true'
    // this.gatedModal = document.querySelector('.modal-marketo-form[data-gated="true"]')
  }

  init () {
    this.buildSplit()
    this.buildTimelineIn()

    if (this.scrollTo) {
      this.buildScrollTo()
    }

    // if (this.isGated && this.gatedModal) {
    //   this.handleGatedContent()
    // }
  }

  handleGatedContent () {
    const hasCompletedForm = localStorage.getItem(`gated_content_${window.location.pathname}`)

    if (!hasCompletedForm) {
      setTimeout(() => {
        const modalEvent = new CustomEvent('openModal', {
          detail: {
            modalId: this.gatedModal.id,
          },
        })
        document.dispatchEvent(modalEvent)
      }, 500)

      document.addEventListener('marketoFormSubmitSuccess', (e) => {
        if (e.detail && e.detail.isGated) {
          localStorage.setItem(`gated_content_${window.location.pathname}`, 'true')
        }
      })
    }
  }

  buildScrollTo () {
    const links = this.scrollTo.querySelectorAll('a')

    links.forEach((el) => {
      el.addEventListener('click', () => {
        const target = document.querySelector(el.getAttribute('href'))
        if (state.smoothScroll) {
          state.smoothScroll.lenis.scrollTo(target)
        } else {
          gsap.to(window, { scrollTo: target, duration: 11.3 })
        }
      })
    })
  }

  buildSplit () {
    if (!this.title) {
      return
    }
    this.split = new SplitText(this.title, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 10,
    })
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1,
      },
    })

    tl.set(this.el, { autoAlpha: 1 })

    if (this.date) {
      tl.fromTo(this.date, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
      }, 0)
    }

    if (this.wysiwyg) {
      tl.fromTo(this.wysiwyg, {
        y: 100,
        autoAlpha: 0,
      }, {
        y: 0,
        autoAlpha: 1,
      }, 0)
    }

    if (this.line) {
      tl.fromTo(this.line, {
        scaleX: 0,
      }, {
        scaleX: 1,
        duration: 1.7,
      }, 0)
    }

    if (this.content) {
      tl.fromTo(this.content, {
        y: 100,
        autoAlpha: 0,
      }, {
        y: 0,
        autoAlpha: 1,
        duration: 1.5,
      }, 0)
    }

    if (this.title) {
      tl.fromTo(this.split.words, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
        stagger: 0.03,
      }, 0)
    }

    if (this.tags.length > 0) {
      tl.fromTo(this.tags, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
      }, 0)
    }

    if (this.image) {
      tl.fromTo(this.image, {
        yPercent: 20,
        clipPath: 'inset(50% round 8px)',
        autoAlpha: 0,
      }, {
        yPercent: 0,
        clipPath: 'inset(0% round 8px)',
        autoAlpha: 1,
      }, 0)
    }
  }

  destroy () {
  }
}

export default PostContent



//////////////////
// WEBPACK FOOTER
// ./scripts/components/PostContent.js
// module id = 55
// module chunks = 0